export default {
  // set document title due to Login routing issues
  setDocumentTitle(title) {
    document.title = title;
  },
};
